import styled from 'styled-components'

const CompanyInfoFooterView = () => {
  return (
    <Wrapper>
      <CompanyName>(주) 유닛미</CompanyName>
      <CompanyInfo>대표이사 김성윤 | 개인정보보호책임자 김성윤</CompanyInfo>
      <CompanyInfo>사업자등록번호 860-81-02511</CompanyInfo>
      <CompanyInfo>통신판매업신고번호 제2022-서울서대문구-0629</CompanyInfo>
      <CompanyInfo>서울 서대문구 연세로 2다길 19, 203호(창천동, 청년창업꿈터)</CompanyInfo>
      <CompanyInfo>admin@unitmi.com | 010-9768-2105</CompanyInfo>
      <TermsAndConditionBlock>
        <LinkBtn
          href="https://picturesque-avatar-ac9.notion.site/20220714-f66e0ed7fa8e4effab515f0e03c286bc"
          target="_blank"
        >
          이용약관
        </LinkBtn>
        <LinkBtn
          href="https://picturesque-avatar-ac9.notion.site/20220714-a0887f910cad40ffb795a341bc4ef14d"
          target="_blank"
        >
          개인정보취급방침
        </LinkBtn>
      </TermsAndConditionBlock>
    </Wrapper>
  )
}

const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: left;
  background: #f7f7f7;
  padding: calc(100vw * (40 / 375)) calc(100vw * (20 / 375));
  color: #121212;
`

const CompanyName = styled.p`
  font-size: calc(100vw * (12 / 375));
  font-weight: 700;
  padding-bottom: calc(100vw * (8 / 375));
  color: #4e4e4e;
`

const CompanyInfo = styled.p`
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (18 / 375));
  white-space: pre-wrap;
  color: #7f7f7f;
`

const TermsAndConditionBlock = styled.div`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  padding-top: calc(100vw * (20 / 375));
`

const LinkBtn = styled.a`
  color: #4e4e4e;
  cursor: pointer;
  &:nth-child(1) {
    padding-right: calc(100vw * (10 / 375));
  }
`

export default CompanyInfoFooterView
